<div>
    <div [innerHTML]="data"></div>
</div>
